export default (function() {
    $('#mobile-menu .mobile-menu-main .menu-item-has-children').append('<div class="open-btn"></div>');

    $('#menu-go-back').click(function() {
      let subMenu = document.getElementById('mobile-menu');
      let target = deepest(subMenu, '.active');
      $(target).removeClass('active');
      let level = deepest(subMenu, '.active');
      $('li', level).removeClass('active-submenu')
      if(subMenu == level) {
        $('#menu-go-back').removeClass('show');
        $('.mobile-top-menu').removeClass('hide');
        $('.mega-menu-container').removeClass('hide');
        $('.menu-item-has-children').removeClass('active-submenu');
        $('.container').removeClass('showing');
      }
    });

    $('#mobile-menu .open-btn').each(function() {
      $(this).click(function(e) {
        const closestListParent = $(this).parent();
        $('#menu-go-back').addClass('show');
        $(closestListParent).addClass('active-submenu');
        $(closestListParent).closest('.container').addClass('showing');
        let parent = $(this).closest('ul');
        if (parent.hasClass('mega-menu')) {
          $('.mobile-top-menu').addClass('hide');
        }
        if (parent.hasClass('mobile-top-menu')) {
          $('.mega-menu-container').addClass('hide');
        }
        $(closestListParent).find('.sub-menu:first').addClass('active');
      });
    });
})();

function deepest (subMenu, select) {
  return [].slice.call (subMenu.querySelectorAll (select)).reduce (
    function (deepest, el) {
      for (var d = 0, e = el; e !== subMenu; d++, e = e.parentNode);
      return d > deepest.d ? {d: d, el: el} : deepest;
    }, {d: 0, el: subMenu}).el;
 }
